export default class RestError {
  constructor(message, status, details) {
    this.message = message;
    this.status = status;
    this.details = details;
  }
}

export class StorageError {
  constructor(message) {
    this.message = message;
  }
}

export class ConnectionError extends RestError {
}

export class ServiceUnavailableError extends RestError {
}

export class UnauthorizedAccessError extends RestError {
}

export class NotFoundError extends RestError {
}

export class ConflictError extends RestError {
}
